import { PropsWithChildren, ReactNode } from 'react';
import { FieldValues } from 'react-hook-form';
import { Button, ButtonProps, cn, Form, FormProps } from '@sib/ui';

export interface BaseDialogFormProps<
  TDefaultValues extends FieldValues,
  TFormattedValues extends FieldValues,
> extends FormProps<TDefaultValues, TFormattedValues> {
  SubmitButtonProps?: ButtonProps & { text: string };
  cancelButton?: ReactNode;
  canSubmit?: boolean;
}

export const BaseDialogForm = <
  TDefaultValues extends FieldValues = FieldValues,
  TFormattedValues extends FieldValues | undefined = undefined,
>({
  children,
  SubmitButtonProps,
  cancelButton,
  canSubmit,
  ...props
}: PropsWithChildren<
  BaseDialogFormProps<
    TDefaultValues,
    TFormattedValues extends undefined ? TDefaultValues : TFormattedValues
  >
>) => {
  const {
    formState: { isSubmitting, isValid: isFormValid },
  } = props;

  const isValid = canSubmit ?? isFormValid;

  return (
    <Form
      {...props}
      className={cn('mt-2 flex h-full flex-col', props.className)}
    >
      <div className="flex flex-1 flex-col items-start gap-4">{children}</div>
      <div className="flex items-center justify-center gap-4 pb-2">
        {cancelButton}
        <Button
          disabled={!isValid}
          type="submit"
          loading={isSubmitting}
          {...SubmitButtonProps}
        >
          {SubmitButtonProps?.text}
        </Button>
      </div>
    </Form>
  );
};
